



































import {Component} from 'vue-property-decorator';
import {TagHelper} from '@/mixins/TagHelper';
import dayjs from 'dayjs';
import clone from '@/lib/clone';
import SelectMonth from '@/components/SelectMonth.vue';
import VEcharts from '@/components/V-Echarts.vue';
import {getDaysInMonth} from '@/lib/date';
import {barChart} from '@/lib/chart';
import Button from '@/components/Button.vue';
import SelectType from '@/components/SelectType.vue';

type map = {
    '+': TRecordType;
    '-': TRecordType;
}
@Component({
    components: {
        SelectType,
        Button,
        VEcharts,
        SelectMonth
    }

})

export default class Labels extends TagHelper {
    SelectMonth = dayjs().month(dayjs(new Date()).month());
    MonthToggle = false;
    SelectTypeDay: '-' | '+' = '+';//每日对比 类型
    map: map = {
        '-': 'expense',
        '+': 'income'
    };

    mounted() {
        console.log((this.$refs.day as HTMLCanvasElement).width);
        console.log((this.$refs.day as HTMLDivElement).scrollLeft=(this.$refs.day as HTMLCanvasElement).scrollWidth);
    }

    get xDayData() {
        return getDaysInMonth(this.SelectMonth);
    }

    get yDayData() {
        return this.getYData(this.xDayData, this.RecordListDay, this.map[this.SelectTypeDay]);
    }

    get dayChartOptions() {
        return barChart(this.xDayData, this.yDayData, this.map[this.SelectTypeDay], '号');
    }

    getYData(days: number[], RecordListsDay: Result, type: TRecordType) {
        return days.map(item => {
            const record = RecordListsDay.find(r => dayjs(r.title).get('date') === item);
            if (record && type === 'income') {
                return record.income;
            } else if (record && type === 'expense') {
                return record.expense;
            } else {
                return 0.00;
            }

        });

    }


    handleMonth() {
        this.MonthToggle = true;
    }

    get Month() {
        return dayjs(this.SelectMonth).format('YYYY年MM月');
    }

    get IncomeTotal() {
        const xxx: number = this.RecordListDay.reduce((sum, b) => {
            return sum + b.income;
        }, 0);
        return xxx;
    }

    get ExpenseTotal() {
        const xxx: number = this.RecordListDay.reduce((sum, b) => {
            return sum + b.expense;
        }, 0);
        return xxx;
    }

    get RecordList(): RecordItem[] {
        return this.$store.state.RecordList;
    }


    get RecordListMonth(): RecordItem[] {   //过滤所选月份
        return this.RecordList.filter(item => {
            return this.SelectMonth.month() === dayjs(item.date).month();

        }).sort((a, b) => {
            return dayjs(b.date).valueOf() - dayjs(a.date).valueOf();
        });
    }

    get RecordListDay() {  //对每个月进行排序
        const newList = clone(this.RecordListMonth);

        if (newList.length > 0) {
            const result: Result = [{
                day: dayjs(newList[0].date).format('dddd'),
                title: dayjs(newList[0].date).format('MM-DD'),
                item: [newList[0]],
                expense: 0,
                income: 0

            }];
            for (let i = 1; i < newList.length; i++) {
                const current = newList[i];
                const last = result[result.length - 1];
                if (dayjs(current.date).isSame(dayjs(last.item[0].date), 'day')) {
                    last.item.push(current);
                } else {
                    result.push({
                        day: dayjs(current.date).format('dddd'),
                        title: dayjs(current.date).format('MM-DD'),
                        item: [current],
                        income: 0,
                        expense: 0
                    });
                }
            }
            result.map(group => {
                group.income = group.item.reduce((sum, b) => {
                    return b.type === '+' ? sum + b.amount : sum;
                }, 0);
            });
            result.map(group => {
                group.expense = group.item.reduce((sum, b) => {
                    return b.type === '-' ? sum + b.amount : sum;
                }, 0);
            });
            return result;

        } else {
            return [];
        }

    }

    created() {
        this.$store.commit('fetchRecords');

    }
}
